<template>
  <div class="blog_component">
    <Header />
    <div class="blog_intro">
      <div class="container">
        <div class="blog_intro_inner">
          <h1 class="blog_intro_title">news about lian</h1>
          <div class="blog_intro_subtitle">Latest News & Insights</div>
        </div>
      </div>
    </div>
    <div class="blog">
      <div class="container">
        <div class="blog_inner">
          <div class="blog_posts">
            <section class="blog_section blog_grid">
              <div class="blog_item">
                <!-- content for /text-post/ -->
                <div class="blog_content">
                  <div class="blog_content-uptitle"><span>WORDPRESS</span></div>
                  <div class="blog_content-title">I am a Blog Post Title</div>
                  <div class="blog_content-author">
                    <i class="fas fa-user blog_content-icon"></i>by Jenn Pereira
                  </div>
                  <div class="blog_content-text">
                    Phasellus et nisl tellus. Etiam facilisis eu nisi
                    scelerisque faucibus. Proin semper suscipit magna, nec
                    imperdiet lacus semper vitae. Sed hendrerit enim non justo
                    posuere placerat eget purus mauris. Etiam facilisis eu nisi
                    scelerisque faucibus...
                  </div>
                  <div class="blog_content-bottom">
                    <div class="blog_content-bottom-date">
                      <i class="far fa-calendar blog_content-icon"></i>on July
                      19, 2020
                    </div>
                    <div>
                      <i class="fas fa-share-alt --post_link --post_share"></i>
                      <i class="fas fa-heart --post_link --post_like"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="blog_item">
                <div class="blog_item_box">
                  <img
                    src="../assets/images/blog/post_pic1.png"
                    class="blog_item_box-picture"
                    alt="post"
                  />
                </div>
                <!-- content for /photo + text-post/ -->
                <div class="blog_content --another_version">
                  <div class="blog_content-title --another_version">
                    I am a Blog Post with an Awesome Image
                  </div>
                  <div class="blog_content-author --another_version">
                    by Jenn Pereira
                  </div>
                  <div class="blog_content-text --another_version">
                    Proin semper suscipit magna, nec imperdiet lacus semper
                    vitae. Sed hendrerit enim non justo posuere placerat eget
                    purus mauris...
                  </div>
                  <div class="blog_content-bottom">
                    <div class="blog_content-bottom-date">
                      <i class="far fa-calendar blog_content-icon"></i>on July
                      19, 2020
                    </div>
                    <div>
                      <i class="fas fa-share-alt --post_link --post_share"></i>
                      <i class="fas fa-heart --post_link --post_like"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="blog_item">
                <div class="blog_item_box">
                  <img
                    src="../assets/images/blog/post_pic2.png"
                    class="blog_item_box-picture"
                    alt="post"
                  />
                </div>
                <!-- content for /photo + text-post/ -->
                <div class="blog_content --another_version">
                  <div class="blog_content-title --another_version">
                    I am a Blog Post with an Awesome Image
                  </div>
                  <div class="blog_content-author --another_version">
                    by Jenn Pereira
                  </div>
                  <div class="blog_content-text --another_version">
                    Proin semper suscipit magna, nec imperdiet lacus semper
                    vitae. Sed hendrerit enim non justo posuere placerat eget
                    purus mauris...
                  </div>
                  <div class="blog_content-bottom">
                    <div class="blog_content-bottom-date">
                      <i class="far fa-calendar blog_content-icon"></i>on July
                      19, 2020
                    </div>
                    <div>
                      <i class="fas fa-share-alt --post_link --post_share"></i>
                      <i class="fas fa-heart --post_link --post_like"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="blog_item"></div>
              <div class="blog_item">
                <div class="blog_item_box --only_photo">
                  <img
                    src="../assets/images/blog/post_pic3.png"
                    class="blog_item_box-picture --only_photo"
                    alt="post"
                  />
                  <div class="blog_content --another_version --only_photo">
                    <div
                      class="blog_content-title --another_version --only_photo"
                    >
                      I am a Blog Post with an Awesome Image
                    </div>
                    <div class="blog_content-author --only_photo">
                      by Jenn Pereira
                    </div>
                    <div
                      class="blog_content-text --another_version --only_photo"
                    >
                      Proin semper suscipit magna, nec imperdiet lacus semper
                      vitae. Sed hendrerit enim non justo posuere placerat eget
                      purus mauris...
                    </div>
                    <div class="blog_content-bottom --only_photo">
                      <div class="blog_content-bottom-date">
                        <i class="far fa-calendar blog_content-icon"></i>on July
                        19, 2020
                      </div>
                      <div>
                        <i
                          class="
                            fas
                            fa-share-alt
                            --post_link --post_share
                            --only_photo
                          "
                        ></i>
                        <i
                          class="
                            fas
                            fa-heart
                            --post_link --post_like
                            --only_photo
                          "
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="blog_item">
                <div class="blog_item_box">
                  <img
                    src="../assets/images/blog/post_pic4.png"
                    class="blog_item_box-picture --biggest_post"
                    alt="post"
                  />
                </div>
                <!-- content for /photo + text-post/ -->
                <div class="blog_content --another_version">
                  <div class="blog_content-title --another_version">
                    I am a Blog Post with an Awesome Image
                  </div>
                  <div class="blog_content-author --another_version">
                    by Jenn Pereira
                  </div>
                  <div class="blog_content-text --another_version">
                    Proin semper suscipit magna, nec imperdiet lacus semper
                    vitae. Sed hendrerit enim non justo posuere placerat eget
                    purus mauris...
                  </div>
                  <div class="blog_content-bottom">
                    <div class="blog_content-bottom-date">
                      <i class="far fa-calendar blog_content-icon"></i>on July
                      19, 2020
                    </div>
                    <div>
                      <i class="fas fa-share-alt --post_link --post_share"></i>
                      <i class="fas fa-heart --post_link --post_like"></i>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="blog_menu" v-on-clickaway="awayBlogMenu">
            <form class="blog_menu_search">
              <label for="search"
                ><i class="fas fa-search blog_menu_search-icon"></i
              ></label>
              <input
                type="text"
                placeholder="Search..."
                class="blog_menu_search-bar"
                name="search"
                autocomplete="off"
              />
            </form>
            <div class="blog_menu_mobile_btn_wrapper" @click="showBlogMenu">
              <div class="blog_menu_mobile_btn"></div>
            </div>
            <div
              class="blog_menu_items_wrapper"
              :class="{ 'blog_menu_item-visible': isBlogMenuVisible }"
            >
              <div class="blog_menu_recent blog_menu_item">
                <div class="blog_menu_header">
                  <div class="blog_menu_header-title">Recent Posts</div>
                </div>
                <div class="recent_item">
                  <img
                    src="../assets/images/blog/blog_menu_pic1.png"
                    alt=""
                    class="recent_item-pic"
                  />
                  <div class="recent_item-content">
                    <div class="recent_item-content-title">
                      Lorem ipsum dolor sit amet, consec
                    </div>
                    <date class="recent_item-content-date">July 5, 2020</date>
                  </div>
                </div>
                <div class="recent_item">
                  <img
                    src="../assets/images/blog/blog_menu_pic2.png"
                    alt=""
                    class="recent_item-pic"
                  />
                  <div class="recent_item-content">
                    <div class="recent_item-content-title">
                      Ut wisi enim ad minim veniam, quis
                    </div>
                    <date class="recent_item-content-date">July 17, 2020</date>
                  </div>
                </div>
                <div class="recent_item">
                  <img
                    src="../assets/images/blog/blog_menu_pic3.png"
                    alt=""
                    class="recent_item-pic"
                  />
                  <div class="recent_item-content">
                    <div class="recent_item-content-title">
                      Aliquip ex ea commodo aliquam erat volutpat
                    </div>
                    <date class="recent_item-content-date">July 21, 2020</date>
                  </div>
                </div>
                <div class="recent_item">
                  <img
                    src="../assets/images/blog/blog_menu_pic4.png"
                    alt=""
                    class="recent_item-pic"
                  />
                  <div class="recent_item-content">
                    <div class="recent_item-content-title">
                      Ut wisi enim ad minim veniam, quis
                    </div>
                    <date class="recent_item-content-date">July 17, 2020</date>
                  </div>
                </div>
              </div>
              <div class="blog_menu_tags blog_menu_item">
                <div class="blog_menu_header">
                  <div class="blog_menu_header-title">Popular tags</div>
                </div>
                <section class="blog_menu_tags_grid">
                  <div class="blog_menu_tags_grid-item">construction</div>
                  <div class="blog_menu_tags_grid-item">engineering</div>
                  <div class="blog_menu_tags_grid-item">architecture</div>
                  <div class="blog_menu_tags_grid-item">structural design</div>
                  <div class="blog_menu_tags_grid-item">civil engineer</div>
                  <div class="blog_menu_tags_grid-item">industrial</div>
                  <div class="blog_menu_tags_grid-item">management</div>
                  <div class="blog_menu_tags_grid-item">mechanical</div>
                </section>
              </div>
              <div class="blog_menu_instagram blog_menu_item">
                <div class="blog_menu_header">
                  <div class="blog_menu_header-title">instagram</div>
                </div>
                <div class="instagram_box">
                  <img
                    src="../assets/images/blog/blog_menu_pic5.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic6.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic7.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic8.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic9.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic10.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic11.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic12.png"
                    alt=""
                    class="instagram_box-item"
                  />
                  <img
                    src="../assets/images/blog/blog_menu_pic13.png"
                    alt=""
                    class="instagram_box-item"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header";
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  data() {
    return {
      isBlogMenuVisible: false,
    };
  },
  components: {
    Header,
  },
  methods: {
    showBlogMenu() {
      this.isBlogMenuVisible = !this.isBlogMenuVisible;
    },
    awayBlogMenu() {
      if (this.isBlogMenuVisible == true) {
        this.showBlogMenu();
      }
    },
  },
};
</script>

<style lang="scss">
.blog_menu_item-visible {
  display: block;
}
</style>